<template>
    <div class="circle_container">
        <div class="current">
            <circle-progress :id="id" :width="150" :radius="12" :progress="current/10*100" :delay="0" :duration="1000"
                :barColor="'#0D94FF'" :backgroundColor="'#eee'" :isAnimation="true"
                :timeFunction="'cubic-bezier(0.99, 0.01, 0.22, 0.94)'" />
        </div>
        <div class="current">
            <div>{{current}}kW</div>
            <div>当前功率</div>
        </div>
        <div class="circle_data">
            <div>{{title}}</div>
            <div>今日发电：{{today}}kWh</div>
            <div>累计发电：{{all}}kWh</div>
        </div>
    </div>
</template>

<script>
    import CircleProgress from "@/components/CircleProgress";
    export default {
        name: "circleitem",
        props: ['id', 'current', 'title', 'today', 'all'],
        components: {
            CircleProgress
        }
    }
</script>

<style lang="less" scoped>
    .circle_container {
        position: relative;
        width: 49%;
        height: 150px;
        margin-left: 10rem;

        .current {
            width: 150px;
            height: 150px;
            position: absolute;
            top: 0;
            left: 0;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;
            font-size: 16rem;
            color: #666;
        }

        .circle_data {
            height: 100%;
            position: absolute;
            left: 182px;
            top: 0;
            display: flex;
            flex-direction: column;
            justify-content: space-evenly;
            color: #333;
            font-weight: bold;
            font-size: 18rem;
        }
    }
</style>